<div class="tt-w-reviews-summary" v-bind="aggregateAttributes">
  <template v-if="dataIsLoaded">
    <tt-user-toolbar></tt-user-toolbar>
    <div v-if="ratingsCount === 0" class="tt-c-reviews-summary__no-reivews">
      <div class="tt-c-reviews-summary__heading tt-u-mb--xs" role="heading" :aria-level="headingLevel" v-html="$msg('reviewsSummary.noReviews')"></div>
      <div class="tt-c-reviews-summary__no-reivews-body tt-u-spacing--md">
        <p class="tt-c-reviews-summary__no-review-text" v-html="$msg('reviewsSummary.beFirstToReview')"></p>
        <tt-actionable-rating-stars starSize="xl" @update:modelValue="writeReview"></tt-actionable-rating-stars>
        <div class="tt-c-reviews-summary__write-review-wrap">
          <tt-button v-if="!isLaunchingWriteReview" type="primary" @click="writeReview" class="tt-c-reviews-summary__write-review" v-html="$msg('reviewsSummary.writeReview')"></tt-button>
          <div v-else class="tt-o-spinner tt-o-spinner--submit"></div>
        </div>
      </div>
    </div>

    <template v-if="ratingsCount > 0 && aggregateMetaOn">
      <meta itemprop="itemReviewed" :content="catItem.title">
      <meta itemprop="name" :content="catItem.title + ' reviews summary'">
      <meta itemprop="ratingValue" :content="rating">
      <meta itemprop="reviewCount" :content="ratingsCount">
    </template>

    <tt-grid-layout v-if="ratingsCount > 0" :layout="currentLayout" classPrefix="tt-c-reviews-summary" class="tt-c-reviews-summary__content">
      <template v-if="!isSlotHidden('ratingsHeader')" v-slot:ratingsHeader>
        <div class="tt-c-reviews-summary__heading tt-u-mb--xs" role="heading" :aria-level="headingLevel" v-html="$msg('reviewsSummary.ratingsCount', [formattedRatingCount], ratingsCount)"></div>
      </template>
      <template v-if="!isSlotHidden('rating')" v-slot:rating>
        <div class="tt-c-reviews-summary__rating tt-u-mb--sm">
          <span class="tt-c-reviews-summary__rating-number">{{ratingFormatted}}</span> <span class="tt-c-reviews-summary__rating-text" v-html="$msg('reviewsSummary.outOfStars')"></span>
        </div>
      </template>
      <template v-if="!isSlotHidden('stars')" v-slot:stars>
        <tt-rating-stars class="tt-c-reviews-summary__stars tt-u-mb--lg" :rating="rating" starSize="xl" :includeAccessibleText="false"></tt-rating-stars>
      </template>
      <template v-if="recommendedPercentageFormatted && !isSlotHidden('recommend')" v-slot:recommend>
        <div class="tt-c-reviews-summary__recommend tt-u-mb--lg">
          <span class="tt-c-reviews-summary__recommend-number">{{recommendedPercentageFormatted}}</span> <span class="tt-c-reviews-summary__recommend-text" v-html="$msg('reviewsSummary.reviewersRecommend')"></span>
        </div>
      </template>
      <template v-if="!isSlotHidden('writeReview')" v-slot:writeReview>        
        <div class="tt-c-reviews-summary__write-review-wrap">
          <tt-button v-if="!isLaunchingWriteReview" type="primary" @click="writeReview" class="tt-c-reviews-summary__write-review tt-u-mb--xl tt-o-button--full" v-html="$msg('reviewsSummary.writeReview')"></tt-button>
          <div v-else class="tt-o-spinner tt-o-spinner--submit"></div>
        </div>
      </template>
      <template v-if="!isSlotHidden('ratingsBreakdown')" v-slot:ratingsBreakdown>
        <tt-ratings-breakdown class="tt-c-reviews-summary__ratings-breakdown"
                              :disableFiltering="disableFiltering"
                              @setFilter="setFilter"
                              :headingLevel="headingLevel + 1"
                              :ratingsBreakdown="ratingsBreakdown"></tt-ratings-breakdown>
      </template>
      <template v-for="(customDim, i) in displayableDimensions" v-slot:[customDim.slotName]>
        <tt-summary-custom-rating v-if="customDim.type === 1"
                                  class="tt-c-reviews-summary__custom-dim"
                                  :headingLevel="headingLevel + 1"
                                  :label="customDim.label"
                                  :averageRating="customDim.average">{{customDim.label}}: {{getFormattedRating(customDim.average)}}</tt-summary-custom-rating>
        <tt-summary-custom-range v-if="customDim.type === 2"
                                 class="tt-c-reviews-summary__custom-dim"
                                 :averageRating="customDim.average"
                                 :headingLevel="headingLevel + 1"
                                 :showMiddleLabel="showRangeMiddle"
                                 :values="customDim.values">{{customDim.label}}</tt-summary-custom-range>
        <tt-summary-custom-select v-if="~[3, 4].indexOf(customDim.type)"
                                  class="tt-c-reviews-summary__custom-dim"
                                  @setFilter="setFilter"
                                  :dim="customDim"
                                  :dimFiltersOn="dimFiltersOn"
                                  :headingLevel="headingLevel + 1"></tt-summary-custom-select>
        <tt-summary-custom-select-image v-if="customDim.type === 5"
                                        class="tt-c-reviews-summary__custom-dim"
                                        :headingLevel="headingLevel + 1"
                                        :label="customDim.label"
                                        :values="customDim.values"></tt-summary-custom-select-image>
      </template>
      <template v-if="hasGallery && !isSlotHidden('gallery')" v-slot:gallery>
        <tt-gallery class="tt-c-reviews-summary__gallery"
                    :galleryConfig="galleryConfig"
                    :headingLevel="headingLevel + 1"
                    :skus="[currentSku]"></tt-gallery>
      </template>
      <template v-if="displayShowDetails" v-slot:showDetails>
        <div class="tt-c-reviews-summary__expander tt-o-expander tt-o-expander--with-dashed-border">
          <tt-button type="toolbar" @click="onShowDetailsClick" class="tt-o-expander__button"><tt-icon name="options-expand" size="sm" class="tt-c-reviews-summary__expander-icon"></tt-icon><span class="tt-o-expander__text" v-html="$msg('reviewsSummary.showDetails')"></span></tt-button>
        </div>
      </template>
      <template v-if="hasSpectrum && !isSlotHidden('spectrum')" v-slot:spectrum>
        <tt-spectrum class="tt-c-reviews-summary__spectrum" :spectrumConfig="spectrumConfig"></tt-spectrum>
      </template>
    </tt-grid-layout>
  </template>
</div>
